import { Pipe, PipeTransform } from '@angular/core'

import { Enums } from '@cyborg-monorepo/hunter/common'
import { Color } from '@hyperkit'

@Pipe({
  name: 'queryStatusColor',
  pure: true,
  standalone: true,
})
export class QueryStatusColorPipe implements PipeTransform {
  transform(status: Enums.QueryStatusEnum): Color {
    switch (status) {
      case Enums.QueryStatusEnum.TO_DO:
        return 'primary'

      case Enums.QueryStatusEnum.RUN:
        return 'success'

      case Enums.QueryStatusEnum.SKIP:
        return 'info'

      default:
        return 'info'
    }
  }
}
